/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import { gql } from '@apollo/client';

export const ReportFragment = {
  reportFields: gql`
    fragment ReportFields on Report {
      _id
      title
      subTitle
      description
      s3File {
        key
        bucket
        originalUrl
      }
      thumbnail {
        key
        bucket
        originalUrl
      }
      status
      type
    }
  `,
};
